<script setup>
import BarChart from '@/components/Graphs/BarChart';
import moment from 'moment/moment';
import { getLeaveReportSummary } from '@/components/Admin/LeaveSummary/services/leave-summary.service.ts';
import { getReformattedSummary } from '@/components/Admin/LeaveSummary/utils/leaveSummaryFormatter.ts';

export default {
    components: { BarChart },
    data() {
        return {
            chartDataMaxTicks: [],
            currentPage: 1,
            limit: 10,
            year: moment().year(),
            chartData: {
                labels: [],
                datasets: [],
                x_stacked: false,
                y_stacked: false,
            },
            chartOptions: {
                responsive: true,
            },
        };
    },
    async mounted() {
        const { data } = await getLeaveReportSummary();
        const { chartData } = getReformattedSummary(data);
        this.chartData.labels = chartData.labels;
        this.chartData.datasets = chartData.dataSets;
    },
};
</script>

<template>
    <BarChart
        :chartdata-sets="chartData.datasets"
        :chartdata-labels="chartData.labels"
        :max-ticks="chartDataMaxTicks"
        :x-stacked="false"
        :y-stacked="false"
    />
</template>

<style scoped lang="scss"></style>
